var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalize } from "../../utils/text.util";
import { Alert, Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useProfileExportFields } from "../../utils/hooks/profile/useProfiles";
import TextField from "@mui/material/TextField";
var ProfileExportConfirmDialog = function (props) {
    var t = useLocalize().t;
    var exportFields = useProfileExportFields();
    var exportFieldsData = exportFields.data || [];
    var _a = React.useState([]), selectedFields = _a[0], setSelectedFields = _a[1];
    useEffect(function () {
        setSelectedFields(exportFieldsData);
    }, [exportFieldsData]);
    var handleCloseDialog = function () {
        var _a;
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        setSelectedFields(exportFieldsData);
    };
    return (_jsxs(Dialog, __assign({ open: props.open, onClose: handleCloseDialog }, { children: [_jsx(DialogTitle, __assign({ id: "alert-dialog-title" }, { children: t("Export profiles") })), _jsx(DialogContent, { children: _jsxs(Stack, __assign({ gap: 3 }, { children: [_jsx(Alert, __assign({ severity: 'info' }, { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: t("".concat(t('Profiles to export'), ": ").concat(props.profilesCount || 0)) })) })), _jsxs(Stack, __assign({ gap: 1 }, { children: [_jsx(Typography, __assign({ variant: 'h6' }, { children: t('Select the fields you want to export') })), _jsx(Autocomplete, { id: 'selected-export-fields-autocomplete', multiple: true, options: exportFieldsData, getOptionLabel: function (option) { return t(option) || ''; }, value: selectedFields, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { fullWidth: true, size: 'small' }))); }, fullWidth: true, onChange: function (e, value) {
                                        setSelectedFields(value);
                                    } })] }))] })) }), _jsxs(DialogActions, __assign({ sx: {
                    justifyContent: 'center'
                } }, { children: [_jsx(Button, __assign({ onClick: handleCloseDialog }, { children: t('Close') })), _jsx(Button, __assign({ onClick: function () {
                            var _a;
                            (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, selectedFields);
                            setSelectedFields(exportFieldsData);
                        }, variant: 'contained' }, { children: t('Confirm') }))] }))] })));
};
export default ProfileExportConfirmDialog;
